import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateExpenseNote from "../pages/ExpenseNote/CreateExpenseNote";
import EditExpenseNote from "../pages/ExpenseNote/EditExpenseNote";
import ExpenseNote from "../pages/ExpenseNote/ExpenseNote";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<ExpenseNote />} />
          <Route path="/expense-note" element={<ExpenseNote />} />
          <Route path="/create" element={<CreateExpenseNote />} />
          <Route path="/edit/:id" element={<EditExpenseNote />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
